import { db } from '~/lib/pwa/db';
import type AuthUser from '~/types/authUser';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', async () => {
    // Only attempt to restore if we are currently offline
    if (navigator.onLine) return;

    try {
      // Find the most recent pending profile update
      const pendingProfileTask = await db.syncQueue
        .where('type')
        .equals('update_profile')
        .filter((task) => task.status === 'pending' || task.status === 'error')
        .last();

      if (pendingProfileTask && 'user' in pendingProfileTask.payload) {
        const { user } = useUserSession();
        // If there is an active session, override its state with the pending offline change
        if (user.value) {
          const offlineUser = pendingProfileTask.payload.user as AuthUser;
          const currentUser = user.value as AuthUser;
          currentUser.roleName = offlineUser.roleName;
          currentUser.companyId = offlineUser.companyId;
          currentUser.companyName = offlineUser.companyName;
          currentUser.companyStatus = offlineUser.companyStatus;

          console.log('[Offline] Contexto de perfil restaurado a partir da fila (Dexie).');
        }
      }
    } catch (error) {
      console.warn('[Offline] Erro ao restaurar contexto de perfil offline:', error);
    }
  });
});
